import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ItemDetalhado} from 'src/app/persistences/item-detalhado';
import {ItemService} from 'src/app/services/item.service';
import {JwtService} from 'src/app/jwt.service';

@Component({
  standalone: false,
  selector: 'app-item-carrinho',
  templateUrl: './item-carrinho.component.html',
  styleUrls: ['./item-carrinho.component.css']
})
export class ItemCarrinhoComponent implements OnInit {

	@Input()
	public itemDetalhado: ItemDetalhado;
	public imagem = "";

	constructor(
		private itemService: ItemService,
		private jwtService: JwtService,
		private cdr: ChangeDetectorRef,
	) {
	}

	ngOnInit() {
		this.itemService.getImagemCached(this.itemDetalhado.itemDetalhes.idItem)
		.subscribe({
			next: (imagem: string) => {
				this.imagem = (imagem && typeof imagem === 'string') ? imagem : '';
				this.cdr.detectChanges();
			},
			error: (error) => this.jwtService.validarAcessToken(error)
		});
	}
}
